import { FileList } from 'slab'
import { type Document } from 'utils/web_api.schemas'

/**
 * Creates a file list from a list of Document (file) objects
 * @param files
 * @returns FileList
 */
export const fileListFromDocuments = (files: Document[]) => (
  <FileList>
    {files.map(file => (
      <FileList.File key={file.id} name={file.filename} size={file.byte_size} status='success' />
    ))}
  </FileList>
)
